export function gaEvents() {

	function check_ga() {
		if (typeof window.ga === 'function') {
			addGaEvents();
		} else {
			setTimeout(check_ga,500);
		}
	}
	check_ga();

}

export function addGaEvents() {

	const ga = window.ga;

	// Click the logo to go home
	const logo = document.querySelector('.site-header .logo');

	if (logo) {
			logo.addEventListener('click', function() {
			ga('send', 'event', 'Click Logo', 'click', window.location.href);
		}, false)
	}

	// Open mobile nav
	const navToggle = document.querySelector('[data-meganav-toggle-main]')

	if (navToggle) {
		navToggle.addEventListener('click', function() {
			ga('send', 'event', 'Open Mobile Nav', 'click', window.location.href);
		}, false);
	}
	
	// Clicking gallery thumbs
	const galleryThumbs = Array.from(document.querySelectorAll('#product-thumbnails .thumb button'));
	
	galleryThumbs.forEach((thumb) => {
		thumb.addEventListener('click', function() {
			ga('send', 'event', 'Clicked Gallery Thumbnail', 'click', window.location.href);
		});
	}, false)

	// Clicking detail toggle on product
	const productDetailToggle = document.querySelector('.product .toggle');

	if (productDetailToggle) {
		productDetailToggle.addEventListener('click', function() {
			ga('send', 'event', 'Clicked Detail Toggle on Product', 'click', window.location.href);
		}, false);
	}
	
	// Clicking recommended product
	const recProds = Array.from(document.querySelectorAll('#recommended-products .card__link'));

	recProds.forEach((prod) => {
		prod.addEventListener('click', function() {
			ga('send', 'event', 'Clicked Recommended Product', 'click', this.href);
		}, false);
	})

	// Clicking recommended character
	const relatedChars = Array.from(document.querySelectorAll('#recommended-characters .card__link'));

	relatedChars.forEach((char) => {
		char.addEventListener('click', function() {
			ga('send', 'event', 'Clicked Recommended Character', 'click', this.href);
		}, false);
	})
	
	// Clicking hero CTA (HOME PAGE)

	const heroLinks = Array.from(document.querySelectorAll('#shopify-section-hero a'));

	heroLinks.forEach((link) => {
		link.addEventListener('click', function() {
			ga('send', 'event', 'Hero CTA Clicked', 'click', this.href);
		}, false);
	});
	
	
	// Clicking featured character (home)
	const popChars = Array.from(document.querySelectorAll('#shopify-section-popular-characters .card__link'));

	popChars.forEach((link) => {
		link.addEventListener('click', function() {
			ga('send', 'event', 'Clicked Featured Character (Homepage)', 'click', this.href);
		}, false);
	});

	// Clicking a-z characters CTA (Home)
	const charAZCta = document.querySelector('#shopify-section-popular-characters .btn')

	if (charAZCta) {
		charAZCta.addEventListener('click', function() {
			ga('send', 'event', 'Clicked Featured Character (Homepage)', 'click', this.href);
		}, false);	
	}

	// Clicking featured products (Home)
	const featuredProds = Array.from(document.querySelectorAll('#shopify-section-featured-products .card__link'));

	featuredProds.forEach((link) => {
		link.addEventListener('click', function() {
			ga('send', 'event', 'Clicked Featured Products (Homepage)', 'click', this.href);
		}, false);
	});

	// Clicking latest news (Home)
	const latestNewsLinks = Array.from(document.querySelectorAll('#shopify-section-latest-news a'));

	latestNewsLinks.forEach((link) => {
		link.addEventListener('click', function() {
			ga('send', 'event', 'Clicked Latest News (Homepage)', 'click', this.href);
		}, false);
	});


	// CLicking Sign Up Block (bottom) 
	const signUpBlock = document.querySelector('#shopify-section-sign-up-block a');
	
	if (signUpBlock) {
		signUpBlock.addEventListener('click', function() {
			ga('send', 'event', 'Clicked Sign up block CTA', 'click', window.location.href);
		}, false);
	}

	// Triggering Size Guide Modal 
	const sizeGuideModalTrigger = document.querySelector('[data-micromodal-trigger="size-guide-modal"]');
	
	if (sizeGuideModalTrigger) {
		sizeGuideModalTrigger.addEventListener('click', function() {
			ga('send', 'event', 'Size Guide Popup Opened', 'click', window.location.href);
		}, false);
	}
	
	// Triggering Delivery Info Modal 
	const deliveryModalTrigger = document.querySelector('[data-micromodal-trigger="delivery-modal"]');
	
	if (deliveryModalTrigger) {
		deliveryModalTrigger.addEventListener('click', function() {
			ga('send', 'event', 'Delivery Popup Opened', 'click', window.location.href);
		}, false);
	}

	// Add to Cart Modal 
	const addToCartModal = document.querySelector('#add-to-cart-modal');

	if (addToCartModal) {
		const continueBtn = addToCartModal.querySelector('#add-to-cart-continue');
		const checkoutBtn = addToCartModal.querySelector('#add-to-cart-checkout');
		const relatedProdAddToCart = Array.from(addToCartModal.querySelectorAll('.modal-product'));

		continueBtn.addEventListener('click', function() {
			ga('send', 'event', 'Clicked continue in add to cart popup ', 'click', window.location.href);
		}, false);
		checkoutBtn.addEventListener('click', function() {
			ga('send', 'event', 'Clicked checkout in add to cart popup ', 'click', window.location.href);
		}, false);

	}

	// related product
	const relatedProds = Array.from(document.querySelectorAll('#related-products a'));
	
	relatedProds.forEach(function(prod) {
		prod.addEventListener('click', function() {
			ga('send', 'event', 'Clicked related product in product page', 'click', window.location.hrefsssss);
		}, false);
	});


	// Clicking Promo CTA (Site wide)
	const promoLinks = Array.from(document.querySelectorAll('.promo a'));

	promoLinks.forEach((link) => {
		link.addEventListener('click', function() {
			ga('send', 'event', 'Clicked Feature Block or Hero', 'click', window.location.href);
		}, false);
	});

		
	// Sorting collection
	const sortBy = document.querySelector('#sort_by');
	
	if (sortBy) {
		sortBy.addEventListener('change', function() {
			ga('send', 'event', 'Collection sorted', 'sort', this.value);
		}, false);
	}
		
	// Opening filter
	const filterToggle = document.querySelector('html:not(.filter-is-open) .filter-toggle')
	
	if (filterToggle) {
		filterToggle.addEventListener('click', function() {
			ga('send', 'event', 'Mobile filter opened', 'click', window.location.href);
		}, false);
	}
		
	// Using collection pagination
	const paginationLinks = Array.from(document.querySelectorAll('#collection-products .pagination a'));

	paginationLinks.forEach((link) => {
		link.addEventListener('click', function() {
			ga('send', 'event', 'Collection pagination used', 'click', this.href);
		});
	});

	// Using collection pagination
	const searchBarSuggestions = Array.from(document.querySelectorAll('.search-bar__suggestion'));
	searchBarSuggestions.forEach((link) => {
		link.addEventListener('click', function() {
			ga('send', 'event', 'Search Bar Suggestion', 'click', this.href);
		});
	});

	// Takeover Banner
	const takeoverBannerLink = document.getElementById('takeover-banner-link');
	if (takeoverBannerLink) {
		takeoverBannerLink.addEventListener('click', (e) => {
			ga('send', 'event', 'Takeover Banner Clicked', 'click', takeoverBannerLink.href);
		}, true);
	}
}


